import { createRouter, createWebHistory } from 'vue-router';

// 路由组件
import HomeView from '../views/HomeView.vue';
import ContactView from '../views/ContactView.vue';
import Product1View from '../views/Product1View.vue';
import Product2View from '../views/Product2View.vue';
import EmailBoxView from '../views/EmailBoxView.vue';
import EmailDetailView from '../views/EmailDetailView.vue';

const routes = [
  { path: '/', name: 'Home', component: HomeView },
  { path: '/contact', name: 'ContactView', component: ContactView },
  { path: '/p01', name: 'Product1View', component: Product1View },
  { path: '/p02', name: 'Product2View', component: Product2View },
  { path: '/mailbox', name: 'EmailBoxView', component: EmailBoxView },
  { path: '/maildetail', name: 'EmailDetailView', component: EmailDetailView },

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
